import * as React from "react";
import { PaymentInstructionLayout } from "../../../../../../../../component/modules/PaymentMethodsList/component/PaymentInstructionLayout.js";
const Twint = () => {
  return /* @__PURE__ */ React.createElement(PaymentInstructionLayout, { info: "checkout.payment.method.twint.info" });
};
export {
  Twint
};
//# sourceMappingURL=Twint.js.map
